import { Col, Input, Row } from "antd";
import { FC, useRef } from "react";

// import "./uploadSalaryRange.less";
import { IModal } from "@types";
import { validateFile } from "@utils";
import UploadModal from "./UploadModal";
import customErrorMessage from "../CustomErrorMessage";

const SAMPLE_FILES_MAP: Record<string, string> = {
  "Upload Job Functions":
    "/samples/Company Job Functions and Job Sub-Functions.csv",
  "Upload Mappings":
    "/samples/Company Job Functions and Job Sub-Functions Mapping.csv",
};

interface IUpload extends IModal {
  onSubmit: any;
  file: File | null;
  title: string;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
}

const Upload: FC<IUpload> = ({
  isVisible,
  setIsVisible,
  onSubmit,
  file,
  setFile,
  title,
}) => {
  const inputRef = useRef<any>(null);

  const uploadFile = async (event: any) => {
    const selectedFile = event?.target?.files?.[0];

    const error = await validateFile(selectedFile);

    if (error) {
      return customErrorMessage(error);
    }

    setFile(selectedFile);
  };

  const resetFile = () => {
    setFile(null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <UploadModal
      width="w-5/12"
      isVisible={isVisible}
      title={title}
      onClose={() => {
        resetFile();
        setIsVisible(false);
      }}
      footer={
        <>
          <button
            className="bg-themeGrey text-themeBlack font-medium text-lg py-2 px-14 rounded-md"
            onClick={() => {
              resetFile();
              setIsVisible(false);
            }}
          >
            Cancel
          </button>
          <button
            className="bg-themeBlue text-white font-medium text-lg py-2 px-14 rounded-md"
            onClick={async () => {
              try {
                await onSubmit();
              } finally {
                resetFile();
                setIsVisible(false);
              }
            }}
            disabled={!file}
          >
            Upload
          </button>
        </>
      }
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col className="uploadSalaryRange__uploadField" span={24}>
            <label className="font-semibold !text-themeInputTitleColor text-lg leading-10">
              Upload File
            </label>

            <Input
              size="large"
              readOnly
              accept=".csv"
              className="w-full shadow-sm font-semibold text-sm outline-none border border-themeInputBorder bg-white rounded-md"
              value={file?.name || ""}
              placeholder="Only CSV is supported"
              addonAfter={
                <button
                  className="bg-themeBlue text-white py-2 px-7 rounded-md"
                  type="button"
                  onClick={() => inputRef?.current?.click()}
                >
                  Upload
                </button>
              }
            />

            {/* Download Sample */}
            <div className="mt-2 ml-1">
              <a
                href={SAMPLE_FILES_MAP[title]}
                download
                className="text-themeBlue font-medium underline cursor-pointer"
              >
                Download Sample File
              </a>
            </div>

            <input
              type="file"
              ref={inputRef}
              hidden
              accept=".csv"
              onChange={uploadFile}
            />
          </Col>
        </Row>
      </>
    </UploadModal>
  );
};

export default Upload;
